import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/baloo-2/latin-700.css";
import "@fontsource/baloo-2/latin-800.css";
import "@fontsource/hind/latin-400.css";
import "@fontsource/hind/latin-600.css";
import "./styles.css";
import { App } from "./App";
import { unlockAudioOnGesture } from "./lib/sound";
import { applyTheme } from "./lib/theme";

applyTheme();
unlockAudioOnGesture();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
